(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["site-footer"] && !Shopify.designMode) return;
  try {
    
  // Columns start closed (the mobile default) and are forced open on desktop,
  // where the accordion is not an affordance we want.
  (() => {
    const query = window.matchMedia('(min-width: 990px)');

    const sync = () => {
      document.querySelectorAll('.site-footer__column').forEach((column) => {
        if (query.matches) {
          column.open = true;
        }
      });
    };

    document.addEventListener('click', (event) => {
      const summary = event.target.closest('.site-footer__column-title');
      if (summary && query.matches) event.preventDefault();
    });

    query.addEventListener('change', sync);
    sync();
  })();

  } catch(e) { console.error(e); }
})();
})();
